import { useScrollProgress } from '@/hooks/useScrollProgress';

/**
 * Cinematic scroll bar: a soft gold hairline at the top of the viewport whose
 * leading edge glows. Combines a thin progress bar with a wider, blurred trail
 * for a more "car headlight on a misty road" feel.
 */
export function ScrollProgress() {
  const progress = useScrollProgress();
  const pct = `${Math.round(progress * 100)}%`;
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px]"
    >
      <div
        className="h-full bg-gradient-to-r from-gold-700 via-gold-500 to-gold-300 transition-[width] duration-fast ease-out-quart"
        style={{ width: pct, boxShadow: '0 0 12px rgba(201,162,39,0.55)' }}
      />
      <div
        className="absolute top-0 h-[3px] w-24 -translate-y-1/2 bg-gradient-to-r from-transparent via-gold-400/60 to-transparent blur-md transition-[left] duration-fast ease-out-quart"
        style={{ left: pct, transform: 'translateX(-100%) translateY(0)' }}
      />
    </div>
  );
}
